import React from 'react';
import styled from '@emotion/styled';

import ProductsListHeading from './ProductsListHeading';
import Column from '../common/layout/Column';
import { OverviewReturnItem } from '../../types';
import NonReturnableProductItem from './NonReturnableProductItem';

type Props = {
  items: OverviewReturnItem[];
};

const Container = styled('div')`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
`;

function NonReturnableProducts(props: Props) {
  const { items } = props;

  if (items.length === 0) {
    return null;
  }

  return (
    <Container data-testid="non-returnable-items">
      <ProductsListHeading>nonReturnableProductsListHeading</ProductsListHeading>
      <Column spacing={24}>
        {items.map(item => (
          <NonReturnableProductItem key={item.productKey} {...item} />
        ))}
      </Column>
    </Container>
  );
}

export default React.memo(NonReturnableProducts);
